<div id="dialog-save" class="dialog-save">
  <ignite-card>
    <div card-title>
      @if (!isSaved) {
        <span i18n>{{ savingMessage }}</span>
      }
      @if (isSaved) {
        <span i18n>{{ savedMessage }}</span>
      }
    </div>
    <div card-content>
      @if (!isSaved) {
        <mat-progress-bar ignite-progress-bar mode="indeterminate"></mat-progress-bar>
      }
    </div>
  </ignite-card>

  @if (!hideOKButton) {
    <div class="ignite-dialog-buttons-container">
      <div class="ignite-buttons">
        <div class="ignite-button-wrapper">
          <button id="button_ok" mat-button class="ignite-button" color="primary" (click)="dialogRef.close(true)">OK</button>
        </div>
      </div>
    </div>
  }
</div>
